import React from 'react';

import { usePreloadImage } from '@ezugi/hooks';
import { DeviceInfo } from '@ezugi/utils/src';

import { logoClassName, gameNameClassName, gameLogoClassName } from '../style.css';

export type PreloaderGameDetailsProps = {
  logo?: string;
  gameName?: string;
  gameLogo?: string;
  showLogo?: boolean;
  showGameName?: boolean;
  showGameLogo?: boolean;
}

export const PreloaderGameDetails: React.FC<PreloaderGameDetailsProps> = ({
  logo,
  gameLogo,
  gameName,
  showGameLogo = false,
  showLogo = false,
  showGameName = false,
}) => {
  const preloadGameLogo = usePreloadImage({ src: gameLogo });
  const preloadLogo = usePreloadImage({ src: logo });
  const shouldShowGameLogo = Boolean(!!showGameLogo && preloadGameLogo.loaded);
  const shouldShowLogo = Boolean(!!showLogo && preloadLogo.loaded);

  return (
    <>
      {shouldShowLogo && (
        <div
          className={logoClassName}
          style={{
            backgroundImage: `url(${logo})`,
          }}
        />
      )}
      {showGameName && <div className={gameNameClassName}>{gameName}</div>}
      {shouldShowGameLogo && (
        <div
          className={gameLogoClassName[DeviceInfo.isHandheld ? 'mobile' : 'desktop']}
          data-name="game-logo"
          style={{ backgroundImage: `url(${gameLogo})` }}
        />
      )}
    </>
  );
};
